<template>
  <el-card>
    <div class="section-title">{{ $t('person.basic') }}</div>
    <el-row style="width: 500px;">
      <el-col class="info-block">
        <el-form
          :model="form"
          :inline-message="true"
          label-position="left"
          label-width="140px"
        >
          <el-form-item label="手机号：" prop="phoneNum">
            <secure-display-text :text="form.phoneNum"></secure-display-text>
          </el-form-item>
          <el-form-item label="账号名称：" prop="username">{{ form.username }}</el-form-item>
          <el-form-item label="头像：" class="img-item">
            <img v-for="(url, index) in form.headImgList" :key="index" :src="url" alt="头像">
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import cloneDeep from 'lodash-es/cloneDeep'
import { mapGetters, mapState } from 'vuex'
import { ROLE_TYPE_ENUM } from '../const'
import SecureDisplayText from '@/components/SecureDisplayText'

export default {
  name: 'Person',
  components: {
    SecureDisplayText
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    ...mapState({
      form: state => {
        let cp
        const { user } = state
        const roleType = user.userInfo.roleType

        if (ROLE_TYPE_ENUM.AI_PUBLISH.code === roleType) {
          cp = user.userInfo
          cp.headImgList = [cp.figureurl]
        }

        cp = cloneDeep(cp) || {}
        cp.roleType = roleType
        cp.channelId = user.channelId
        return cp
      }
    }),
    logoUrl() {
      const photo = (this.form.companyPhotoList && this.form.companyPhotoList[0]) || {}
      return photo.url || ''
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.pic {
  height: 200px;
  width: 200px;
  text-align: center;
  box-shadow: #ccc 0 0 10px;
}

.logo-block {
  width: 300px;
  margin-right: 24px;
}
.info-block {
  flex-grow: 1;
}
.el-form-item {
  margin: 0;
  padding: 8px 0;

  &.img-item {
    img {
      width: 150px;
      height: 150px;

      & + img {
        margin-left: 10px;
      }
    }
  }

  &:not(.img-item) {
    /deep/ .el-form-item__content {
      border-bottom: 1px solid rgba($primary, .5);
    }
  }
}
</style>
